import { Injectable, inject } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import {
    BookingV2DialogComponent,
    BookingV2DialogData,
} from '../booking-v2-dialog.component';

/**
 * Öffnet den neuen Buchungsdialog (Beta).
 *
 * Wird von den Einstiegspunkten (Bootliste, Liegeplan, Personenliste,
 * generelle Neu-Buchung) aufgerufen, sobald `betaFeatures.bookingDialogV2`
 * im Tenant aktiviert ist.
 */
@Injectable({ providedIn: 'root' })
export class BookingV2DialogService {

    private readonly dialog = inject(DialogService);

    open(data?: BookingV2DialogData): DynamicDialogRef {
        return this.dialog.open(BookingV2DialogComponent, {
            data,
            modal: true,
            closable: false,
            showHeader: false,
            width: '960px',
            style: { maxWidth: '95vw', maxHeight: '92vh' },
            styleClass: 'booking-v2-dialog-panel',
        });
    }
}
